import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeChatModule from './backoffice-chat.module'
import BackofficeChatStore from './store/backoffice-chat-store'

@Component({
  ...BackofficeChatModule,
})
export default class ComponentBackofficeChat extends Vue {
  mounted() {
    this.backofficeChatStore.reset()
    this.backofficeChatStore.loadChats()
  }

  get backofficeChatStore() {
    return getModule(BackofficeChatStore, this.$store)
  }
}
